export default __webpack_public_path__ + "static/media/iconWhatsapp.616d1d8c.svg";